import seasonsCropsStorage from '@/services/storage/seasonsCropsStorage.js'
import store from '@/store'

const currentStore = store

const loadSeasonCrops = async () => {
  const currentCrop = currentStore.getters['crops/currentCrop']
  const seasonsCrops = currentStore.getters['seasonsCrops/seasonsCrops']

  const storedSeasonCrop = seasonsCropsStorage().crop(currentCrop?.id).get()

  await currentStore.dispatch(
    'seasonsCrops/setCurrentSeasonCrop',
    storedSeasonCrop ?? seasonsCrops[0]
  )
}

const getUserPermissions = async () => {
  const isPermissionsLoaded =
    currentStore.getters['permissions/isPermissionsLoaded']

  if (isPermissionsLoaded) return

  currentStore.dispatch('permissions/setIsPermissionsLoaded', true)

  try {
    await currentStore.dispatch('crops/fetchCrops')
    await currentStore.dispatch('seasonsCrops/fetchSeasonsCrops')
    await currentStore.dispatch('crops/loadCurrentCropByStorage')
    await loadSeasonCrops()
    await currentStore.dispatch('permissions/fetchPermissions')
  } catch (error) {
    currentStore.dispatch('permissions/setIsPermissionsLoaded', false)
    console.error(error)
  }
}

export { getUserPermissions }
